import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { PAYLOAD_DATE_FORMAT, VIEWED_FILTER_KIND, getQueryParams, updateQueryString } from "../../utils"

/****************Ragnar Lodbrok****************/
import moment from "moment"
import { Grid } from "@material-ui/core"
import {
	getFromEmails,
	getToEmails,
	getUsers,
	getSources,
	getDynamicToEmails,
	getDynamicFromEmails,
	getDynamicToEmailsReset,
	getDynamicFromEmailsReset,
} from "../../actions/infoActions"
import {
	FileTypes,
	DropdownWithSearch,
	DateRange,
	Tags,
	CommentsBy,
	View,
	Reset,
	SortByRelevance,
	HasAttachment,
	GetLatestFiles,
} from "../../components/Filters"
import { setFilterData } from "../../actions/filterActions"
import _ from "lodash"
import { requestCustomTags } from "../../actions/customTagsActions"
import { resetSelectedIdsAction } from "../../actions/downloadsActions"
import { history } from "../../helpers/history"
import { getAllDocumentsRequest } from "../../actions/viewdocumentsActions"
import { useTranslation } from "react-i18next"

const useFilters = ({
	setPage = () => {},
	ref = {},
	fetchData = () => {},
	debouncedCallback = () => {},
	sortModel = [],
	setSortModel = () => {},
	disableFilters = false,
	// resetFilter = false,
	// setResetFilter = () => {},
	// canApplyFilter = false,
	//setCanApplyFilter = () => {},
	toRetainFilters = false,
}) => {
	const dispatch = useDispatch()
	const [t] = useTranslation("global")

	const fromEmailsList = useSelector((state) => state.info?.fromEmailsList)
	const toEmailsList = useSelector((state) => state.info?.toEmailsList)
	const isFromEmailsLoading = useSelector((state) => state.info?.isFromEmailsLoading)
	const isToEmailsLoading = useSelector((state) => state.info?.isToEmailsLoading)
	const from = useSelector((state) => state.filter?.from)
	const to = useSelector((state) => state.filter?.to)
	const dateRange = useSelector((state) => state.filter?.dateRange)
	const fileTypes = useSelector((state) => state.filter?.fileTypes)
	const has_attachment = useSelector((state) => state.filter?.has_attachment)
	const tagsFilterData = useSelector((state) => state.filter?.tags)
	const commentsBy = useSelector((state) => state.filter?.commentsBy)
	const viewFilterData = useSelector((state) => state.filter?.view)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const isReviewFormOpen = useSelector((state) => state.review?.isReviewFormOpen)
	const allDocumentsList = useSelector((state) => state.viewdocuments.allDocuments)
	const globalStateSearchDocumentList = useSelector((state) => state.timeline.timelineResults)
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const filtersData = useSelector((state) => state.filter)
	const [isEmailFilter, setIsEmailFilter] = useState(false)
	const [canApplyFilter, setCanApplyFilter] = useState(false)
	const [resetFilter, setResetFilter] = useState(false)

	const attachmentOptions = [
		{
			id: 0,
			name: t("filters.withoutAttachment"),
		},
		{
			id: 1,
			name: t("filters.withAttachment"),
		},
		{
			id: -1,
			name: t("filters.clear"),
		},
	]

	const initialFilters = {
		source: { kind: 110, data: [] },
		tags: { kind: 110, data: [] },
		tagged_date: { kind: 211, data: [] },
		commentator: { kind: 110, data: [] },
		from: { kind: 110, data: [] },
		to: { kind: 110, data: [] },
		view_count: { kind: VIEWED_FILTER_KIND.default, data: 0 },
		subject: "",
		has_attachment: [],
	}

	const [filters, setFilters] = useState(_.cloneDeep(initialFilters))
	const [queryParams, setQueryParams] = useState({})
	const [fromDynamicEmailList, setFromDynamicEmailList] = useState([])
	const [toDynamicEmailList, setToDynamicEmailList] = useState([])

	const checkIfClearFilterApplies = (excludeKey) => {
		let canApplyFilter = false
		for (let i of Object.keys(filters)) {
			if (i === "view_count") {
				canApplyFilter =
					filters[i]?.kind === VIEWED_FILTER_KIND.viewed || filters[i]?.kind === VIEWED_FILTER_KIND.not_viewed ? true : false
			} else {
				canApplyFilter = filters[i]?.data?.length > 0 ? true : false
			}
			if (canApplyFilter) {
				break
			}
		}
		return canApplyFilter
	}

	const resetReducerFilterValues = () => {
		dispatch(
			setFilterData({
				fileTypes: [],
				dateRange: { startDate: "", endDate: "" },
				from: [],
				to: [],
				tags: [],
				commentsBy: [],
				view: "",
				subject: "",
				has_attachment: [],
			})
		)
	}

	useEffect(() => {
		return () => {
			resetReducerFilterValues()
		}
	}, [])

	useEffect(() => {
		dispatch(getUsers())
		dispatch(getFromEmails())
		dispatch(getToEmails())
		dispatch(getSources())
		dispatch(requestCustomTags())
		if (toRetainFilters) {
			return
		}
		handleReset()
	}, [selectedBaseId])

	useEffect(() => {
		if (toRetainFilters) {
			setResetFilter((prevState) => false)
			return
		}
		if (resetFilter) {
			resetReducerFilterValues()
			setFilters((prevData) => ({
				source: { kind: 110, data: [] },
				tags: { kind: 110, data: [] },
				tagged_date: { kind: 211, data: [] },
				commentator: { kind: 110, data: [] },
				from: { kind: 110, data: [] },
				to: { kind: 110, data: [] },
				view_count: { kind: VIEWED_FILTER_KIND.default, data: 0 },
				has_attachment: [],
			}))
			setPage((prevData) => 1)
			setSortModel((prevData) => [])
			setResetFilter((prevState) => false)
		}
		setIsEmailFilter(false)
		dispatch(getDynamicToEmailsReset())
		dispatch(getDynamicFromEmailsReset())
	}, [resetFilter])

	useEffect(() => {
		setCanApplyFilter((prevState) => checkIfClearFilterApplies())
		ref.current = fetchData
	}, [filters])

	useEffect(() => {
		if (toRetainFilters) {
			return
		}
		setPage((prevData) => 1)
		debouncedCallback()
	}, [filters])

	useEffect(() => {
		const queryString = getQueryParams()

		if (!_.isEmpty(queryString)) {
			setQueryParams((prev) => queryString)
		}
	}, [allDocumentsList, globalStateSearchDocumentList, conceptDocs])

	useEffect(() => {
		if (toEmailsList?.length) {
			setToDynamicEmailList(toEmailsList)
		}
	}, [toEmailsList])

	useEffect(() => {
		if (fromEmailsList?.length) {
			setFromDynamicEmailList(fromEmailsList)
		}
	}, [fromEmailsList])

	useEffect(() => {
		if (isEmailFilter) {
			dispatch(getDynamicToEmails(queryParams))
			dispatch(getDynamicFromEmails(queryParams))
		}
	}, [allDocumentsList, globalStateSearchDocumentList, queryParams, conceptDocs])

	const handleFileTypeChange = (fileTypes) => {
		dispatch(resetSelectedIdsAction())
		setIsEmailFilter((prevData) => fileTypes[0] === "email" && fileTypes.length === 1)
		setFilters((prevData) => ({
			...prevData,
			source: { ...prevData.source, data: fileTypes },
			from: { ...prevData?.from, data: [] },
			to: { ...prevData?.to, data: [] },
		}))
	}

	const handleDateRangeChange = (dateRange) => {
		dispatch(resetSelectedIdsAction())
		if (dateRange?.startDate && dateRange?.endDate) {
			let createDateRange = [
				moment(dateRange.startDate).format(PAYLOAD_DATE_FORMAT),
				moment(dateRange.endDate).format(PAYLOAD_DATE_FORMAT),
			]

			setFilters((prevData) => ({ ...prevData, tagged_date: { ...prevData.tagged_date, data: createDateRange } }))
			return
		}
		setFilters((prevData) => ({ ...prevData, tagged_date: { ...prevData.tagged_date, data: [] } }))
	}

	const handleTagChange = (tag) => {
		dispatch(resetSelectedIdsAction())
		setFilters((prevData) => ({ ...prevData, tags: { ...prevData.tags, data: tag } }))
	}

	const handleAttachmentChange = (attaachment) => {
		dispatch(resetSelectedIdsAction())
		setFilters((prevData) => ({ ...prevData, has_attachment: attaachment }))
	}

	const handleCommentByChange = (commenters) => {
		dispatch(resetSelectedIdsAction())
		setFilters((prevData) => ({ ...prevData, commentator: { ...prevData.commentator, data: commenters } }))
	}

	const handleViewedTypeChange = (viewedType) => {
		dispatch(resetSelectedIdsAction())
		setFilters((prevData) => ({ ...prevData, view_count: { ...prevData.view_count, kind: viewedType } }))
	}

	const handleEmailFromChange = (emailFromList) => {
		dispatch(resetSelectedIdsAction())
		setFromDynamicEmailList((prev) => fromEmailsList)
		setFilters((prevData) => ({ ...prevData, from: { ...prevData.from, data: emailFromList } }))
	}

	const handleEmailToChange = (emailToList) => {
		dispatch(resetSelectedIdsAction())
		setToDynamicEmailList((prev) => toEmailsList)
		setFilters((prevData) => ({ ...prevData, to: { ...prevData.to, data: emailToList } }))
	}

	const handleReset = () => {
		dispatch(resetSelectedIdsAction())
		setResetFilter((prevState) => true)
	}

	const handleSortByRelevance = () => {
		dispatch(resetSelectedIdsAction())
		setSortModel?.([])
		debouncedCallback()
	}

	const handleGetLatestFiles = (sortOrder) => {
		setSortModel((prev) => [sortOrder])
	}

	const fromHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ from: value }))
	}

	const toHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ to: value }))
	}

	const dateRangeHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ dateRange: value }))
	}

	const fileTypesHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ fileTypes: value }))
	}

	const tagsHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ tags: value }))
	}

	const attachmentHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ has_attachment: value }))
	}

	const commentsByHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ commentsBy: value }))
	}

	const viewHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ view: _.isNumber(value) ? value : "" }))
	}

	const subjectSearchHandler = (value) => {
		dispatch(resetSelectedIdsAction())
		dispatch(setFilterData({ subject: value }))
	}

	const filtersDom = (
		<Grid container style={{ margin: "15px 0 20px 0" }} alignItems="center" justifyContent="space-between">
			<Grid item spacing={2}>
				<Grid container spacing={2} alignItems="center">
					<FileTypes
						handleFileTypeChange={handleFileTypeChange}
						selected={fileTypes}
						setSelected={fileTypesHandler}
						disableFilters={disableFilters || isReviewFormOpen}
					/>
					{isEmailFilter && (
						<>
							<DropdownWithSearch
								label="Sender"
								handleListChange={handleEmailFromChange}
								list={fromDynamicEmailList}
								isLoading={isFromEmailsLoading}
								selectedOptions={from}
								setSelectedOptions={fromHandler}
								disableFilters={disableFilters || isReviewFormOpen}
							/>

							<DropdownWithSearch
								label="Receiver"
								handleListChange={handleEmailToChange}
								list={toDynamicEmailList}
								isLoading={isToEmailsLoading}
								selectedOptions={to}
								setSelectedOptions={toHandler}
								disableFilters={disableFilters || isReviewFormOpen}
							/>

							<HasAttachment
								handleAttachmentChange={handleAttachmentChange}
								selected={has_attachment}
								setSelected={attachmentHandler}
								disableFilters={disableFilters || isReviewFormOpen}
								attachmentOptions={attachmentOptions}
							/>
						</>
					)}

					<DateRange
						handleDateRangeChange={handleDateRangeChange}
						dateRange={dateRange}
						setDateRange={dateRangeHandler}
						disableFilters={disableFilters || isReviewFormOpen}
					/>
					<Tags
						handleTagChange={handleTagChange}
						selected={tagsFilterData}
						setSelected={tagsHandler}
						disableFilters={disableFilters || isReviewFormOpen}
					/>
					<CommentsBy
						handleCommentByChange={handleCommentByChange}
						selected={commentsBy}
						setSelected={commentsByHandler}
						disableFilters={disableFilters || isReviewFormOpen}
					/>
					<View
						handleViewedTypeChange={handleViewedTypeChange}
						viewType={viewFilterData}
						setViewType={viewHandler}
						disableFilters={disableFilters || isReviewFormOpen}
					/>
					<Reset canApplyFilter={canApplyFilter && !isReviewFormOpen} handleReset={handleReset} />
				</Grid>
			</Grid>
			<Grid item>
				<Grid container direction="row" justifyContent="flex-start" alignItems="center">
					<SortByRelevance isDisabled={!sortModel.length} onClickHandler={handleSortByRelevance} />
					<GetLatestFiles isDisabled={isReviewFormOpen} onClickHandler={handleGetLatestFiles} />
				</Grid>
			</Grid>
		</Grid>
	)

	return {
		filtersDom,
		filters,
		isEmailFilter,
		handleReset,
		setFilters,
		fromHandler,
		toHandler,
		dateRangeHandler,
		fileTypesHandler,
		tagsHandler,
		commentsByHandler,
		viewHandler,
		setIsEmailFilter,
		setResetFilter,
		initialFilters,
		handleDateRangeChange,
		subjectSearchHandler,
		attachmentHandler,
		handleGetLatestFiles,
	}
}

export default useFilters
